module.exports = __webpack_public_path__ + "img/icon23.14d5a669.png";